<template>
    <div class="creat">
        <el-form ref="form" :model="form" label-width="100px" size="large" :rules="rules">
            <el-form-item label="考试名称" prop="examName">
                <el-input v-model="form.examName"></el-input>
            </el-form-item>
            <el-form-item label="考试类型">
                <el-radio-group v-model="form.examType">
                    <el-radio :label="1">私有考试</el-radio>
                    <el-radio :label="2">公开考试</el-radio>
                    <el-radio :label="3">模拟考试</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="考试描述">
                <el-input v-model="form.examSubscribe" type="textarea"></el-input>
            </el-form-item>
            <el-form-item label="考试时间" prop="times">
                <el-date-picker
                    v-model="form.times"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    @change="handleChange"
                ></el-date-picker>
            </el-form-item>
            <el-form-item label="temp">
                <span slot="label" class="el-icon-question">
                    <el-tooltip class="item" effect="dark" placement="right-start">
                        <div slot="content">
                            <p>题目乱序：本功能打开后，题序会自动生成</p>
                            <p>选项乱序：单选及多选选项顺序随机生成；</p>
                        </div>
                        <span>防作弊设置</span>
                    </el-tooltip>
                </span>
                <el-checkbox-group v-model="form.antiCheating">
                    <el-checkbox :label="1">题目乱序</el-checkbox>
                    <el-checkbox :label="2">选项乱序</el-checkbox>
                    <el-checkbox :label="3" @change="cutScreen">
                        切屏
                        <el-input
                            type="number"
                            max="5"
                            size="mini"
                            min="0"
                            :disabled="cut"
                            v-model.number="form.screen"
                            style="width: 60px"
                        ></el-input>次强制交卷
                    </el-checkbox>
                </el-checkbox-group>
                <p v-if="!cut">最多设置切屏5次（聊天软件、杀毒防护软件会影响效果，请谨慎使用该功能。）</p>
            </el-form-item>
            <el-form-item style="text-align:right">
                <el-button @click="$router.go(-1)">取消</el-button>
                <el-button type="primary" @click="onSubmit('form')">下一步</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
export default {
    data () {
        return {
            form: {
                antiCheating: [],
                examType: 2 // 试卷类型   1 私有  2 公开  3 模拟
            },
            rules: {
                examName: [
                    { required: true, message: "请输入考试名称", trigger: "blur" }
                ],
                times: [
                    { type: 'array', message: '请设置考试时间', required: true, trigger: 'blur' }
                ]
            },
            open: true,
            cut: true
        };
    },
    props: {
        raceExpUid: { type: String },
        isAdd: { type: Boolean }
    },
    methods: {
        handleChange (val) {
            if (val && val.length === 2) {
                this.form.startTime = val[0]
                this.form.endTime = val[1]
            }
        },
        cutScreen () {
            this.cut = !this.cut;
            if (this.cut == true) {
                this.form.screen = 1;
            }
        },
        onSubmit () {
            this.$refs['form'].validate(valid => {
                let { startTime, endTime } = this.form
                let { antiCheating, examSubscribe, examType, examName, screen } = JSON.parse(JSON.stringify(this.form))
                if (typeof startTime === 'object') {
                    startTime = startTime.getTime()
                }
                if (typeof endTime === 'object') {
                    endTime = endTime.getTime()
                }
                if (valid) {
                    if (screen < 1) {
                        screen = 1
                    }
                    if (screen > 5) {
                        screen = 5
                    }
                    for (let i = 0; i < antiCheating.length; i++) {
                        if (antiCheating[i] === 3) {
                            antiCheating[i] += ':' + screen
                        }
                    }
                    this.$emit("submit", {
                        antiCheating: antiCheating.join(','),
                        examSubscribe,
                        examType,
                        examName,
                        startTime,
                        endTime
                    });
                }
            })
        }
    }
};
</script>
<style lang="less">
</style>

<style lang="less" scoped>
.creat {
    min-height: 500px;
    margin-top: 20px;
    .creat-contant {
        margin-top: 36px;
        background-color: #fff;
        min-height: 800px;
        padding: 20px;
    }
}
</style>

